<script setup lang="ts">
import { formatTimestamp } from '@/utils/dateUtils'
import { EProviders, type ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'

const generateTitle = (detection?: Record<string, ExtendedPrimitives>) =>
    `Bib ${detection?.bib}${detection?.event_filter ? ` - E${detection?.event_filter}` : ''}${
        detection?.checkpoint_name ? ` - ${detection?.checkpoint_name}` : ''
    }`
const generateSubtitle = (detection?: Record<string, ExtendedPrimitives>) =>
    formatTimestamp(detection?.timestamp as Date | string)

provide(EProviders.DETECTION, {
    generateTitle,
    generateSubtitle,
    advancedFiltersQueryKeys: ['start_at', 'end_at']
})
</script>

<template>
    <slot />
</template>
